import { render, staticRenderFns } from "./DeleteWatchlistModal.vue?vue&type=template&id=0036f26e&scoped=true"
import script from "./DeleteWatchlistModal.vue?vue&type=script&lang=js"
export * from "./DeleteWatchlistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036f26e",
  null
  
)

export default component.exports